import { render, staticRenderFns } from "./GradesName.vue?vue&type=template&id=641f4417&scoped=true"
import script from "./GradesName.vue?vue&type=script&lang=js"
export * from "./GradesName.vue?vue&type=script&lang=js"
import style0 from "./GradesName.vue?vue&type=style&index=0&id=641f4417&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f4417",
  null
  
)

export default component.exports